<template>
  <v-dialog v-model="dialog" width="600px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title>Danh sách IMEI / SERIAL</v-card-title>
      <v-card-text>
        <div class="red--text">{{ model.code }} / {{ model.description }}</div>
        <v-progress-linear class="my-2" v-if="loading" indeterminate></v-progress-linear>
        <v-select
          class="mt-4"
          dense
          outlined
          label="Kho"
          item-text="text"
          item-value="value"
          :items="allInventories"
          @change="data => onSearch(data, 'inventory')"
        ></v-select>
        <v-select
          dense
          outlined
          label="Lựa chọn mã"
          :items="codes"
          @change="data => onSearch(data, 'productState')"
        ></v-select>
        <div v-if="deliveryproductsHasImei.length">
          <table>
            <tr v-for="item in deliveryproductsHasImei" :key="item.id">
              <td>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div class="text-ellipsis" :style="{ width: '150px' }" v-on="on" v-bind="attrs">
                      {{ item.imei || 'Chưa có imei' }}
                    </div>
                  </template>
                  <span>{{ item.imei || 'Chưa có imei' }}</span>
                </v-tooltip>
              </td>
              <td :style="{ width: '150px', 'text-align': 'center' }">
                <div class="red--text">{{ handerCode(item) }}</div>
              </td>
              <td :style="{ width: '200px' }">
                <div>
                  <span class="gray--text ml-4">Nhập ngày</span>
                  <span :style="{ color: 'black', 'font-weight': '500' }">
                    {{ item.deliveredAt ? moment(item.deliveredAt).format('DD/MM/YYYY') : '' }}
                  </span>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="mt-4" v-else>Chưa có dữ liệu</div>
      </v-card-text>
      <v-divider class="gray--text"></v-divider>
      <v-card-actions v-if="deliveryproductsHasImei.length" class="d-flex flex-column align-end">
        <v-data-footer
          items-per-page-text="Số dữ liệu mỗi trang"
          @update:options="pagination => onPaginationChange(pagination)"
          :items-per-page-options="[5, 10]"
          :options="{
            page: page,
            itemsPerPage: itemsPerPage
          }"
          :pagination="{
            page: page,
            itemsPerPage,
            pageStart: (page - 1) * itemsPerPage,
            pageStop: page * itemsPerPage,
            itemsLength: count
          }"
        >
        </v-data-footer>
        <v-btn color="primary" class="elevation-0 mt-4"
          ><v-icon class="mr-2" size="17">mdi-download</v-icon>Tải xuống file PDF</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import moment from 'moment'
export default {
  name: 'DialogListImei',
  data() {
    return {
      loading: false,
      itemsPerPage: 5,
      moment,
      dialog: false,
      model: {
        code: 0,
        description: ''
      },
      codes: [
        { text: 'Tất cả', value: '' },
        { text: 'Mã vỏ xấu', value: 'container', color: 'warning' },
        { text: 'Mã hãng còn nợ', value: 'null', color: 'error' }
      ],
      page: 1,
      pageStart: 0,
      pageStop: 5,
      filter: {
        inventory: '',
        productState_null: ''
      },
      allInventories: [],
      payload: null
    }
  },
  async mounted() {
    await this.changeItems()
  },
  computed: {
    ...mapGetters({
      importDeliveryProducts: 'importDeliveryProduct/items',
      count: 'importDeliveryProduct/count'
    }),
    ...mapState({
      inventories(state) {
        return state['inventories'].items
      }
    }),
    pageSizeStart() {
      return (this.page - 1) * this.itemsPerPage + 1
    },
    pageSizeEnd() {
      const appendIndex = this.page * this.itemsPerPage
      return appendIndex > this.count ? this.count : appendIndex
    },
    deliveryproductsHasImei() {
      return this.importDeliveryProducts
    }
  },
  methods: {
    ...mapActions({
      fetchImportDeliveryProduct: 'importDeliveryProduct/fetchItems',
      countImportDeliveryProduct: 'importDeliveryProduct/countItems',
      fetchInventories: 'inventories/fetchItems'
    }),
    async openDialog(payload) {
      this.loading = true
      this.dialog = true
      this.model = payload.model
      this.payload = payload
      await this.fetchImportDeliveryProduct({
        productModel: this.model._id,
        inventory: payload.inventoryId,
        _start: (this.page - 1) * this.itemsPerPage,
        _limit: this.itemsPerPage
      })
      await this.countImportDeliveryProduct({ productModel: this.model._id, inventory: payload.inventoryId })
      this.loading = false
    },
    handerCode(code) {
      if (code.deliveredAt) return ''
      switch (code.productState) {
        case 'container':
          return 'Mã vỏ xấu'
        case null:
          return 'Hãng còn nợ'
        default:
          return ''
      }
    },
    onPaginationChange(page) {
      this.itemsPerPage = page.itemsPerPage
      this.page = page.page
      this.onRefresh()
    },
    async onRefresh() {
      await this.fetchImportDeliveryProduct({
        productModel: this.model._id,
        inventory: this.payload.inventoryId,
        _start: (this.page - 1) * this.itemsPerPage,
        _limit: this.itemsPerPage,
        ...this.filter
      })
      await this.countImportDeliveryProduct({ productModel: this.model._id, inventory: this.payload.inventoryId })
    },
    async onSearch(data, type) {
      if (type === 'inventory') this.filter.inventory = data
      else if (type === 'productState') this.filter.productState_null = data
      await this.onRefresh()
    },
    async changeItems() {
      const res = await this.fetchInventories()
      this.allInventories = res.map(i => {
        return {
          text: i.name,
          value: i.id
        }
      })
      this.allInventories.unshift({ text: 'Tất cả', value: '' })
    }
  }
}
</script>
